jQuery( function($) {
    $(document).ready( function() {

        $('.new-clean-beauty__controller--item').on('click', function(){
            let item = $(this).attr('data-option-item');
            $('.new-clean-beauty__controller--item').removeClass('active');
            $(this).addClass('active');
            $('.main-block').fadeOut(5);
            $('.main-block[data-option-item = '+item+']').fadeIn(100);
        });

    });
});